if (!customElements.get('split-slider')) {
  class SplitSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = {
        loop: true,
        draggable: true,
        slidesPerView: 1,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
      };

      this.slider = new Swiper(this.querySelector('.swiper'), this.options);
    }
  }

  customElements.define('split-slider', SplitSlider);
}
